export const recipesEs = {
  title: 'Recetas y listas de materiales',
  subtitle: 'Fórmulas versionadas y auditables con BOM multinivel.',
  empty: 'Ninguna versión coincide con los filtros.',
  pagination: 'Página {{page}} de {{pages}} · {{total}} versiones',
  help: {
    open: 'Abrir ayuda de recetas y BOM',
    list: 'Filtra por ciclo de vida, producto de salida, componente o validez.',
    header:
      'El número y el producto de salida identifican la receta estable. El contenido cambia mediante versiones controladas.',
    translations:
      'Los nombres y descripciones se guardan por separado para cada idioma compatible.',
    components:
      'Las posiciones referencian artículos o subrecetas aprobadas. Cantidades y costes usan decimales exactos.',
    dmsSnapshot:
      'Selecciona los originales DMS protegidos que pertenecen exactamente a esta versión.',
    history: 'Las versiones aprobadas permanecen inmutables y pueden copiarse a un nuevo borrador.',
    impact:
      'Muestra las recetas padre directas y todos los productos afectados en toda la jerarquía BOM.',
    productUsage:
      'Selecciona un componente para mostrar cada receta y producto que lo usa directamente.',
  },
  actions: {
    new: 'Nueva receta / BOM',
    alternatives: 'Alternativas',
    submit: 'Enviar a revisión',
    review: 'Completar revisión',
    approve: 'Aprobar',
    copy: 'Copiar versión',
    block: 'Bloquear',
    archive: 'Archivar',
    addComponent: 'Añadir posición',
    compare: 'Comparar versiones',
    addAlternative: 'Añadir alternativa',
    reject: 'Rechazar',
  },
  filters: {
    search: 'Buscar número, receta o producto',
    status: 'Estado del ciclo de vida',
    allStatuses: 'Todos los estados',
    validOn: 'Válida el',
    componentSearch: 'Buscar artículo, receta, posición o comentario',
  },
  columns: {
    number: 'Número',
    name: 'Nombre',
    output: 'Producto de salida',
    version: 'Versión',
    status: 'Estado',
    reference: 'Cantidad de referencia',
    components: 'Posiciones',
    cost: 'Coste de material',
    validity: 'Validez',
    updated: 'Último cambio',
  },
  statuses: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    APPROVED: 'Aprobada',
    BLOCKED: 'Bloqueada',
    ARCHIVED: 'Archivada',
  },
  componentTypes: {
    MATERIAL: 'Material',
    SUB_RECIPE: 'Subreceta',
    PACKAGING: 'Embalaje',
    BY_PRODUCT: 'Subproducto',
  },
  substitutionStatuses: {
    PROPOSED: 'Propuesta',
    APPROVED: 'Aprobada',
    REJECTED: 'Rechazada',
    ARCHIVED: 'Archivada',
  },
  editor: {
    newTitle: 'Crear receta / BOM',
    newDescription: 'Crea la identidad estable y su primera versión editable.',
    versionDescription: 'Versión controlada v{{version}}',
    reorder: 'Reordenar posición',
  },
  fields: {
    number: 'Número de receta / BOM',
    outputProduct: 'Producto de salida',
    name: 'Nombre',
    baseQuantity: 'Cantidad de referencia',
    baseUnit: 'Unidad base',
    validFrom: 'Válida desde',
    validTo: 'Válida hasta',
    currency: 'Moneda de coste',
    comments: 'Comentarios internos',
    localizedName: 'Nombre localizado',
    description: 'Descripción',
    position: 'Posición',
    type: 'Tipo de posición',
    component: 'Componente',
    quantity: 'Cantidad',
    unit: 'Unidad',
    percentage: 'Porcentaje %',
    loss: 'Pérdida %',
    declarationRelevant: 'Relevante para declaración',
    alternatives: 'Alternativas',
    comment: 'Comentario',
    selectSubRecipe: 'Seleccionar subreceta aprobada',
    selectProduct: 'Seleccionar artículo',
    alternativeProduct: 'Artículo alternativo',
    alternativeRecipe: 'Subreceta alternativa',
    factor: 'Factor de sustitución',
    rationale: 'Justificación técnica',
    reason: 'Motivo y nota de decisión',
  },
  sections: {
    header: 'Cabecera de receta',
    translations: 'Idiomas',
    components: 'Componentes y subrecetas',
    snapshotDocuments: 'Instantánea documental',
    history: 'Historial de versiones',
    whereUsed: 'Recetas padre y productos afectados',
    affectedProducts: 'Todos los productos afectados en todos los niveles de BOM',
    productUsage: 'Uso del componente seleccionado',
    documents: 'Expediente DMS de receta',
  },
  summary: {
    quantities: 'Totales por unidad',
    percentage: 'Total de porcentajes',
    cost: 'Coste de material calculado',
  },
  warnings: {
    UNIT_NOT_SUMMABLE: 'La posición {{position}} no puede convertirse a la unidad base {{unit}}.',
    COMPONENT_ARCHIVED: 'El artículo de la posición {{position}} está archivado.',
    SUB_RECIPE_NOT_APPROVED: 'La subreceta de la posición {{position}} no está aprobada.',
    PERCENTAGE_TOTAL_NOT_100:
      'Los porcentajes mantenidos suman {{percentage}} % en lugar de 100 %.',
    INPUT_OUTPUT_DEVIATION:
      'Las entradas convertibles ({{input}} {{unit}}) difieren de la salida de referencia ({{output}} {{unit}}).',
  },
  states: {
    invalidDecimal: 'Decimal no válido',
    noDocuments: 'No hay documentos de receta protegidos.',
    notUsed: 'No se encontraron usos.',
  },
  messages: {
    saved: 'Versión de receta guardada.',
    invalid: 'Corrige los datos no válidos.',
    submitted: 'Receta enviada a revisión independiente.',
    workflowUpdated: 'Flujo de receta actualizado.',
  },
  tabs: {
    editor: 'Editor',
    history: 'Versiones y comparación',
    impact: 'Uso / impacto',
    processRouting: 'Ruta de proceso',
    documents: 'Documentos DMS',
  },
  alternatives: {
    title: 'Componentes alternativos y sustituciones aprobadas',
    empty: 'No hay alternativas definidas para esta posición.',
  },
  actionDialog: {
    REVIEW: {
      title: 'Completar revisión técnica',
      description: 'Confirma la revisión independiente con una nota trazable.',
    },
    APPROVE: {
      title: 'Aprobar versión',
      description: 'La aprobación inmoviliza la versión y aplica el principio de cuatro ojos.',
    },
    COPY: {
      title: 'Copiar a una nueva versión',
      description: 'Se crea un borrador editable y se revisan de nuevo las sustituciones.',
    },
    BLOCK: {
      title: 'Bloquear versión',
      description: 'La versión sigue inmutable pero ya no puede utilizarse.',
    },
    ARCHIVE: {
      title: 'Archivar versión',
      description: 'La versión sigue siendo trazable y sale del uso activo.',
    },
    SUB_APPROVE: {
      title: 'Aprobar sustitución',
      description: 'Confirma independientemente la equivalencia técnica y su evidencia.',
    },
    SUB_REJECT: {
      title: 'Rechazar sustitución',
      description: 'Documenta por qué no debe usarse la alternativa.',
    },
  },
  compare: {
    title: 'Comparar versiones',
    description: 'Las diferencias proceden de instantáneas inmutables.',
    headerChanges: 'Cambios de cabecera',
    none: 'Sin cambios de cabecera.',
    added: 'Posiciones añadidas',
    removed: 'Posiciones eliminadas',
    changed: 'Posiciones modificadas',
  },
  compareFields: {
    name: 'Nombre',
    baseQuantity: 'Cantidad de referencia',
    baseUnitCode: 'Unidad base',
    validFrom: 'Válido desde',
    validTo: 'Válido hasta',
    comments: 'Comentarios',
    dmsAttachmentIds: 'Instantánea documental DMS',
    costCurrency: 'Moneda de coste',
    internalMaterialCost: 'Coste de material',
    translations: 'Traducciones',
  },
} as const;
